module.exports = __webpack_public_path__ + "static/media/team-introduction-2.a6b4f3e2.jpg";